<template>
  <div v-if="isAuth" :class="'overflow-hidden container-fluid shadow p-0 position-relative ' + (isMenuOpen ? 'sidebar-open' : '' )">
    <Header v-on:toogle-menu="toogleMenu" />
    <Menu />
    <Error />

    <div class="content-wrapper">
      <Favorites v-if="view === 'favorites'" />
      <Client v-else :key="'client-' + clientsKey" />
    </div>
  </div>

  <Login v-else/>
</template>

<script>
  import Header from './components/common/Header';
  import Menu from './components/common/Menu';
  import Error from './components/common/Error';
  import Login from './components/Login';
  import Client from './components/Client';
  import Favorites from './components/Favorites';
  import {
    INTERVAL_UPDATE_USER_DATA,
    INTERVAL_UPDATE_CATALOGS,
  } from './constants';

  export default {
    components: {Header, Menu, Login, Client, Favorites, Error},

    data() {
      return {
        isMenuOpen: false,
        clientsKey: 0,
      };
    },

    created() {
      this.loadData();
    },

    computed: {
      view: function () {
        return this.$store.state.view;
      },

      isAuth: function () {
        return this.$store.getters.isAuthorized;
      },
    },

    watch: {
      view: function () {
        if (this.$store.state.view === 'clients') {
          this.clientsKey++;
        }

        this.toogleMenu();
      },

      isAuth() {
        this.loadCatalogs();
        this.loadUsersData();
      },
    },

    methods: {
      async loadData() {
        await this.loadCatalogs();
        await this.loadUsersData();

        setInterval(() => {
          this.loadCatalogs();
        }, INTERVAL_UPDATE_CATALOGS);

        setInterval(() => {
          this.loadUsersData();
        }, INTERVAL_UPDATE_USER_DATA);
      },

      async loadCatalogs() {
        if (!this.isAuth) {
          return;
        }

        try {
          await Promise.all([
            this.$store.dispatch('LOAD_CATALOGS'),
            this.$store.dispatch('LOAD_FORMATS'),
            this.$store.dispatch('LOAD_INGREDIENTS'),
            this.$store.dispatch('LOAD_METHODS'),
            this.$store.dispatch('LOAD_TIMES'),
            this.$store.dispatch('LOAD_DRUGS'),
          ]);
        } catch(e) {
          await this.$store.dispatch('ERROR', e);
        }
      },

      async loadUsersData() {
        if (!this.isAuth) {
          return;
        }

        try {
          await Promise.all([
            this.$store.dispatch('LOAD_CLIENTS'),
            this.$store.dispatch('LOAD_DRUG_STATS'),
            this.$store.dispatch('LOAD_FAVORITES_DRUG_PRESCRIPTIONS'),
          ]);
        } catch(e) {
          await this.$store.dispatch('ERROR', e);
        }
      },

      toogleMenu() {
        this.isMenuOpen = !this.isMenuOpen;
      },
    },
  };
</script>